import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import React from 'react';
import { RenderElementProps } from 'slate-react';
import { EXPLANATION, EXPLANATIONS } from './types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ExplanationElementEditable = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent<RenderElementProps>(() =>
    import(/* webpackExports: "ExplanationElementEditable" */'./components/ExplanationElement').then((mod) => mod.ExplanationElementEditable)
  )
);
const ExplanationsElement = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent<RenderElementProps>(() =>
    import('./components/ExplanationsElement').then((mod) => mod.ExplanationsElement)
  )
);

export const renderElementExplanations = (options?: any) => (props: RenderElementProps) => {
  const { element } = props;
  switch (element.type) {
    case EXPLANATIONS:
      return <ExplanationsElement isEditable {...props} />;

    case EXPLANATION:
      return <ExplanationElementEditable {...props} />;

    default:
      return undefined;
  }
};
